// Module
var code = `<div class="filters">
    <div class="labelled-field labelled-field--long">
        <label for="filter-command-status" class="add-on">Status</label>
        <select id="filter-command-status" class="form-control" ng-model="\$ctrl.filterCommandStatus"
                ng-options="commandStatus.type as commandStatus.label for commandStatus in \$ctrl.commandStatuses">
        </select>
    </div>      
</div>
<table class="table" ng-table="\$ctrl.tableConfig">
    <tbody>
    <tr ng-repeat="item in \$data">
        <td data-title="'No'">
            {{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}
        </td>
        <td data-title="'Registration time'">{{item.registrationTime | prettyDateTime}}</td>
        <td data-title="'Execution time'">{{item.executionTime | prettyDateTime}}</td>
        <td data-title="'Action'"><span title="{{item.simpleName}}">{{item.displayName}}</span></td>
        <td data-title="'Amount'">{{\$ctrl.getRuleAttributeValue(item.ruleAttributes, 'AMOUNT') | nxCurrency}}</td>
        <td data-title="'Status'">
            <span class="status--warning" ng-class="{'status--success': item.status == 'EXECUTED', 'status--danger': ['REJECTED', 'FAILED'].includes(item.status)}">
                {{item.status}}</span>
        </td>
        <td data-title="'Approved by'">{{item.approvedByUser}}</td>
        <td data-title="'Rejected by'">{{item.rejectedByUser}}</td>
        <td data-title="'Prints'"><span ng-if="item.prints.length > 0">
            <button type="button" class="btn btn-print" ng-click="\$ctrl.displayPrints(item)" title="{{item.printCodes.join(', ') | prettyEnum}}">Print</button>
        </span></td>
    </tr>
    </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/actions/action-commands.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;